
export default function Services() {
  return (
    <section id="services" className="py-24 bg-gradient-to-br from-[#F8F9F6] to-[#F1F4ED]">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <h2 
              className="text-3xl md:text-4xl lg:text-5xl font-light text-[#2C3E2D] mb-8 leading-tight tracking-tight"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Nos <span className="italic">services</span> de <span className="font-medium">conciergerie</span>
            </h2>
            <div className="w-20 h-0.5 bg-[#6B7C59] mx-auto mb-10"></div>
            <p 
              className="text-lg md:text-xl text-[#4A5240] max-w-3xl mx-auto leading-relaxed font-light"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              Une gamme complète de services pour optimiser vos <span className="font-normal">locations saisonnières à Perpignan</span> et dans les Pyrénées-Orientales
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service 1 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#6B7C59]/5">
              <div className="w-16 h-16 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mb-6">
                <i className="ri-home-4-line text-3xl text-[#6B7C59]"></i>
              </div>
              <h3 
                className="text-xl md:text-2xl font-normal text-[#2C3E2D] mb-4 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Gestion locative complète
              </h3>
              <p 
                className="text-base text-[#4A5240] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Prise en charge intégrale de vos locations saisonnières : annonces, réservations, accueil des voyageurs et suivi personnalisé.
              </p>
            </div>

            {/* Service 2 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#6B7C59]/5">
              <div className="w-16 h-16 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mb-6">
                <i className="ri-sparkling-2-line text-3xl text-[#6B7C59]"></i>
              </div>
              <h3 
                className="text-xl md:text-2xl font-normal text-[#2C3E2D] mb-4 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Ménage & entretien
              </h3>
              <p 
                className="text-base text-[#4A5240] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Nettoyage professionnel entre chaque séjour, entretien régulier et maintenance préventive de votre propriété.
              </p>
            </div>

            {/* Service 3 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#6B7C59]/5">
              <div className="w-16 h-16 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mb-6">
                <i className="ri-customer-service-2-line text-3xl text-[#6B7C59]"></i>
              </div>
              <h3 
                className="text-xl md:text-2xl font-normal text-[#2C3E2D] mb-4 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Accueil personnalisé
              </h3>
              <p 
                className="text-base text-[#4A5240] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Remise des clés, présentation du logement et assistance 24h/7j pour garantir un séjour parfait à vos hôtes.
              </p>
            </div>

            {/* Service 4 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#6B7C59]/5">
              <div className="w-16 h-16 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mb-6">
                <i className="ri-shield-check-line text-3xl text-[#6B7C59]"></i>
              </div>
              <h3 
                className="text-xl md:text-2xl font-normal text-[#2C3E2D] mb-4 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Surveillance & sécurité
              </h3>
              <p 
                className="text-base text-[#4A5240] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Visites régulières, vérifications de sécurité et intervention rapide en cas de problème ou d'urgence.
              </p>
            </div>

            {/* Service 5 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#6B7C59]/5">
              <div className="w-16 h-16 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mb-6">
                <i className="ri-tools-line text-3xl text-[#6B7C59]"></i>
              </div>
              <h3 
                className="text-xl md:text-2xl font-normal text-[#2C3E2D] mb-4 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Maintenance & réparations
              </h3>
              <p 
                className="text-base text-[#4A5240] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Coordination des interventions techniques, réparations d'urgence et amélioration continue de votre bien.
              </p>
            </div>

            {/* Service 6 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#6B7C59]/5">
              <div className="w-16 h-16 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mb-6">
                <i className="ri-line-chart-line text-3xl text-[#6B7C59]"></i>
              </div>
              <h3 
                className="text-xl md:text-2xl font-normal text-[#2C3E2D] mb-4 tracking-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                Optimisation des revenus
              </h3>
              <p 
                className="text-base text-[#4A5240] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Stratégie tarifaire dynamique, amélioration du taux d'occupation et maximisation de votre rentabilité locative.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
